export var DocsBlockBehaviorSelectionType;
(function (DocsBlockBehaviorSelectionType) {
    /** Allows selection of data entities only */
    DocsBlockBehaviorSelectionType["entity"] = "Entity";
    /** Allows selection of groups only */
    DocsBlockBehaviorSelectionType["group"] = "Group";
    /** Allows combined selection of data entities and groups */
    DocsBlockBehaviorSelectionType["entityAndGroup"] = "EntityAndGroup";
})(DocsBlockBehaviorSelectionType || (DocsBlockBehaviorSelectionType = {}));
